import React from "react";
import { string } from "prop-types";
import { Col } from "../Grid";
import LogoLink from "../LogoLink";

const FooterLogoV3 = ({ logoPath, logoAlt = "", href = "/" }) => {
	return (
		<Col sm={12} md="shrink">
			<div className="footer__logo-v3">
				<LogoLink imgSrc={logoPath} alt={logoAlt} href={href} />
			</div>
		</Col>
	);
};

FooterLogoV3.propTypes = {
	logoPath: string.isRequired,
	logoAlt: string,
	href: string,
};

export default FooterLogoV3;
